module.exports = __webpack_public_path__ + "img/zip_08_cervena.be1fac81.png";